import { render } from "./PostMortem.vue?vue&type=template&id=cd01bd94&scoped=true"
import script from "./PostMortem.vue?vue&type=script&lang=js"
export * from "./PostMortem.vue?vue&type=script&lang=js"

import "./PostMortem.vue?vue&type=style&index=0&id=cd01bd94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd01bd94"]])

export default __exports__